import api from 'api/api'
import { toast } from 'react-toastify'
import { urlPdfs } from 'constants/urls'

export const GET_SUPPLIER_ORDERS = '[SUPPLIER ORDERS] GET SUPPLIER ORDERS'
export const SAVE_SUPPLIER_ORDER = '[SUPPLIER ORDERS] SAVE SUPPLIER ORDER'
export const FINISH_SUPPLIER_ORDER = '[SUPPLIER ORDERS] FINISH SUPPLIER ORDER'
export const ACCEPT_SUPPLIER_ORDER = '[SUPPLIER ORDERS] ACCEPT SUPPLIER ORDER'
export const VOID_SUPPLIER_ORDER = '[SUPPLIER ORDERS] VOID SUPPLIER ORDER'

export function getSupplierOrdersAction(filters = { startDate: '', endDate: '', status: '', search: '', pageSize: 10 }) {
  const request = api.get(`/supplier-orders/registers`, { params: filters })
  return (dispatch) => {
    dispatch({ type: GET_SUPPLIER_ORDERS, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_SUPPLIER_ORDERS, payload: { ...response.data.data } })
    }).catch((error) => {
      console.log(GET_SUPPLIER_ORDERS, error)
    }).finally(() => {
      dispatch({ type: GET_SUPPLIER_ORDERS, payload: { loading: false } })
    })
  }
}

export function saveSupplierOrderAction(data) {
  const request = api.post(`/supplier-order/save`, data)
  return (dispatch) => {
    dispatch({ type: SAVE_SUPPLIER_ORDER, payload: { saving: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SAVE_SUPPLIER_ORDER, payload: { saved: true, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(SAVE_SUPPLIER_ORDER, error)
    }).finally(() => {
      dispatch({ type: SAVE_SUPPLIER_ORDER, payload: { saving: false } })
    })
  }
}

export function finishSupplierOrderAction(supplierOrderId) {
  const request = api.post(`/supplier-order/${supplierOrderId}/finish`)
  return (dispatch) => {
    dispatch({ type: FINISH_SUPPLIER_ORDER, payload: { finishing: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: FINISH_SUPPLIER_ORDER, payload: { finished: true, data: response.data.data } })
      window.open(`${urlPdfs.ordenCompraA4}/${supplierOrderId}`)
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(FINISH_SUPPLIER_ORDER, error)
    }).finally(() => {
      dispatch({ type: FINISH_SUPPLIER_ORDER, payload: { finishing: false } })
    })
  }
}

export function acceptSupplierOrderAction(supplierOrderId) {
  const request = api.post(`/supplier-order/${supplierOrderId}/accept`)
  return (dispatch) => {
    dispatch({ type: ACCEPT_SUPPLIER_ORDER, payload: { accepting_id: supplierOrderId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: ACCEPT_SUPPLIER_ORDER, payload: { accepted_id: supplierOrderId, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(ACCEPT_SUPPLIER_ORDER, error)
    }).finally(() => {
      dispatch({ type: ACCEPT_SUPPLIER_ORDER, payload: { accepting_id: supplierOrderId } })
    })
  }
}

export function voidSupplierOrderAction(supplierOrderId) {
  const request = api.delete(`/supplier-order/${supplierOrderId}/void`)
  return (dispatch) => {
    dispatch({ type: VOID_SUPPLIER_ORDER, payload: { voiding_id: supplierOrderId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: VOID_SUPPLIER_ORDER, payload: { voided_id: supplierOrderId, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(VOID_SUPPLIER_ORDER, error)
    }).finally(() => {
      dispatch({ type: VOID_SUPPLIER_ORDER, payload: { voiding_id: supplierOrderId } })
    })
  }
}